import * as React from "react"
import { Link } from "@mui/material"

import { DownloadButton } from "../@components"


export default function actionsColumn() {
	return {
		name: "url",
		setBodyCellProps: () => ({ sx: { textAlign: 'center'} }),
		render: value => <Link href={value} target="_blank">
			<DownloadButton icon={"cloud-arrow-down"} label={"Download Report"} sx={{width: 175}} />
		</Link>
	}
}